import React from 'react';
import { a as _taggedTemplateLiteral } from './_rollupPluginBabelHelpers-53ddb3bb.js';
import styled from 'styled-components';
import { b as getMargin } from './styled-utils-3f8463ca.js';

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  border-right: ", ";\n  height: 100%;\n  width: 1px;\n  ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  border: none;\n  border-bottom: ", ";\n  width: 100%;\n  ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var HorizontalSeparator = styled.hr(_templateObject(), function (_ref) {
  var theme = _ref.theme;
  return theme.borders.separator;
}, function (_ref2) {
  var theme = _ref2.theme;
  return getMargin('m-0', theme);
});
var VerticalSeparator = styled.div(_templateObject2(), function (_ref3) {
  var theme = _ref3.theme;
  return theme.borders.separator;
}, function (_ref4) {
  var theme = _ref4.theme;
  return getMargin('m-0', theme);
});

var Separator = function Separator(_ref) {
  var isVertical = _ref.isVertical,
      className = _ref.className;
  return isVertical ? React.createElement(VerticalSeparator, {
    className: className
  }) : React.createElement(HorizontalSeparator, {
    className: className
  });
};

Separator.defaultProps = {
  className: null,
  isVertical: false
};
Separator.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Separator",
  "props": {
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A custom className you would like to pass to the Component"
    },
    "isVertical": {
      "defaultValue": {
        "value": "false",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": "Whether or not to render a vertical separator"
    }
  }
};
export default Separator;
export { Separator };